import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/indicator_active.png'
import _imports_1 from '@/assets/images/indicator_no_active.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-fe6178fc")

_pushScopeId("data-v-fe6178fc")
const _hoisted_1 = { class: "banner-indicator-item" }
const _hoisted_2 = {
  class: "banner-indicator-icon",
  src: _imports_0
}
const _hoisted_3 = {
  class: "banner-indicator-icon",
  src: _imports_1
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("img", _hoisted_2, null, 512), [
      [_vShow, _ctx.isActive()]
    ]),
    _withDirectives(_createVNode("img", _hoisted_3, null, 512), [
      [_vShow, !_ctx.isActive()]
    ])
  ]))
})